// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"495327c0","702":"f5ad3814"}[chunkId] + ".chunk.js";
};